import type CustomIcon from "@/assets/icons/CustomIcon";
import { HStack } from "@/components/ui/hstack";
import { Text } from "@/components/ui/text";
import { Pressable } from "react-native";

interface DrawerItemProps {
  label: string;
  onPress?: () => void;
  icon: typeof CustomIcon;
  visible?: boolean;
}

const DrawerItem: React.FC<DrawerItemProps> = ({ label, onPress, icon: Icon, visible = true }: Readonly<DrawerItemProps>) => {
  return (
    visible && (
      <Pressable onPress={onPress}>
        <HStack className="items-center gap-[20px]">
          <Icon />
          <Text className="font-[600] leading-[22px] text-[16px] text-typography-900">{label}</Text>
        </HStack>
      </Pressable>
    )
  );
};

export default DrawerItem;
